export default __webpack_public_path__ + "static/media/BIH.aedb4fa8.svg";